import { INavigation } from '../types';

const searchByConstant: (constants: any, id: string, key: string) => string = (
  constants,
  id,
  key
) => {
  return constants?.find((item: INavigation) => item.id === id)[key];
};

export default searchByConstant;
